import { OrganisationLevel } from '@/constants/admin/OrganisationLevel'
import { ModelApiService } from './BaseApiService'

export default class CandidateApiService extends ModelApiService {
  constructor() {
    super('Candidate')
  }

  async getCandidateMessagesById(id) {
    return await this.get(`${id}/messages/sms`)
  }

  async getMyCandidateSMSs() {
    return await this.get(`mine/sms`)
  }

  async getMyTeamSMSs() {
    return await this.get(`mesages/team`)
  }

  async readMessages(payload) {
    return await this.patch(`messages/read`, payload)
  }

  async sendMessage(payload) {
    return await this.post(`${payload.id}/messages`, payload)
  }

  async getCandidateGuaranteed(payload) {
    let id = payload.id

    // TODO: Remove this logic when refactoring filter to org tree filter.
    //       The below extracts the team id from the concatinated team and division id
    //       e.g. 55_23
    if (payload.level === OrganisationLevel.Team) {
      const splitStr = id.split('_')
      id = splitStr[0]
    }

    return await this.get(
      `Guaranteed?level=${payload.level}&id=${id}&type=${payload.type}&date=${payload.date}`
    )
  }

  /**
   * Retrieves a Candidate's user details from the API.
   * @param {number} candidateId
   */
  async getUserDetails(candidateId) {
    return await this.get(`${candidateId}/user-details`)
  }

  /**
   * Create a login for a Candidate.
   * @param {number} candidateId
   */
  async createLogin(candidateId) {
    return await this.post(`${candidateId}/user`)
  }

  /**
   * Synchronises a Candidate's login email to their email.
   * @param {number} candidateId
   */
  async syncLoginEmail(candidateId) {
    return await this.post(`${candidateId}/sync-email`)
  }

  /**
   * Removes a Candidate's Ready2Work login.
   * @param {number} candidateId
   */
  async removeLogin(candidateId) {
    return await this.delete(`${candidateId}/user`)
  }

  /**
   * Requests to reset a candidate's password.
   * @param {number} candidateId
   */
  async resetPassword(candidateId) {
    return await this.post(`${candidateId}/reset-password`)
  }

  async getBullhornData(candidateId) {
    return await this.get(`${candidateId}/bullhorn`)
  }

  /**
   * Marks a candidate's registration interview as complete.
   * @param {number} candidateId - The ID of the candidate
   * @param {number} registrationId - The ID of the registration
   */
  async completeRegistrationInterview(candidateId, registrationId) {
    return await this.post(
      `${candidateId}/registrations/${registrationId}/interview/complete`
    )
  }

  /**
   * Retrieves a specific registration step submission for a candidate.
   * @param {number} candidateId - The ID of the candidate
   * @param {number} registrationId - The ID of the registration
   * @param {string} stepCodeName - The code name of the registration step
   */
  async getRegistrationStepSubmission(
    candidateId,
    registrationId,
    stepCodeName
  ) {
    return await this.get(
      `${candidateId}/registrations/${registrationId}/submission/${stepCodeName}`
    )
  }
}
